










import Vue from 'vue'
import Component from "vue-class-component";

import {  Watch } from "vue-property-decorator";
let videoProcessInterval;
@Component

export default class Viedo extends Vue {
    videoUrl=''
    iconPlayShow=false
    isVideoShow=true
    beforeCreate() {
        console.log(333)
    
    }
    updated() {
     console.log(233)   
    }
    @Watch('$route')
    getUrl(to: any, from: any){
        if(to.name=='video'){
        let url:any= String(to.query.videoUrl);
        this.videoUrl=url;
        // console.log(to.query.videoUrl) 

        }
    }
    mounted() {
    //   console.log(this.$route.query.videoUrl)   
    
        let url:any= String(this.$route.query.videoUrl);
        this.videoUrl=url;
    }
    playvideo(event:any) {
                let video:any = document.querySelectorAll('video')[0];
                this.isVideoShow = false;
                this.iconPlayShow = false;
                // this.showShareBox = false;
                video.play();
                window.onresize = function () {
                    video.style.width = window.innerWidth + "px";
                    video.style.height = window.innerHeight + "px";
                }
 
                // videoProcessInterval = setInterval(() => {
                //     this.changeProcess(video)
                // }, 100)
    }
    
    //记录播放进度
            // changeProcess() {
            //     let video = document.querySelectorAll('video')[this.current];
            //     let currentTime = video.currentTime.toFixed(1);
            //     let duration = video.duration.toFixed(1);
            //     this.videoProcess = parseInt((currentTime / duration).toFixed(2) * 100)
            // }
}
